export type ImpersonationClaims = {
  isImpersonating: true
  impersonatorUid: string
  impersonationSessionId: string
}

export const isImpersonationSession = (
  claims: Record<string, unknown> | null | undefined,
): claims is Record<string, unknown> & ImpersonationClaims =>
  !!claims &&
  claims.isImpersonating === true &&
  typeof claims.impersonatorUid === 'string' &&
  claims.impersonatorUid.length > 0 &&
  typeof claims.impersonationSessionId === 'string' &&
  claims.impersonationSessionId.length > 0
